export default __webpack_public_path__ + "static/media/hash.40750d13.svg";